<template>
  <div class="content">
    <div class="left">
      <!--真正下载的邀请函，隐藏-->
      <div style="overflow: hidden; width:0;height:0">
        <!--            <div>-->
        <!--  -->
        <div id="imageWrapperEN" ref="imageWrapperEN" class="downloadposter">
          <div class="headImg">
            <img src="../../../../static/wxHead2en.png" alt="" />
          </div>
          <div v-if="form.imageUrl" class="logoIMG">
            <img :src="form.imageUrl" :style="styleImg" />
          </div>
          <div v-else class="logo">LOGO</div>
          <div style="">
            {{ companychName }}
            <p style="font-size: 42px; margin-top: 49px">
              You are cordially invited to visit
            </p>
            <p style="font-size: 42px; margin-top: 10px">
              We participated in the China's 19th International Technology Exchange & Equipmnet Exhibition on
            </p>
          </div>
          <div class="exnumbox" style="margin-top: 39px">
            <div class="exnum1" v-if="booth[selectedBooth]">
              Booth
              <div style="font-size:50px;line-height: 60px">{{ booth[selectedBooth].Num }}</div>
            </div>
            <div class="address1">
              <p>
                New China International Exhibition Center(NEIEC) Beijing, China
              </p>
              <p>25-28 October 2023</p>
            </div>
          </div>
          <div style="margin-top: 150px">
            <p v-if="form.phone" style="margin-top: 31px; margin-bottom: 45px">Phone Nubmer:{{ form.phone }}</p>
            <p v-else style="margin-top: 31px; margin-bottom: 45px">
              Phone Nubmer:XXXXXXXXXXX
            </p>
          </div>
          <!-- 二维码 -->
          <div class="qrcodeEnn">
            <div style="font-size: 48px;width:100%">
              <div id="qrcodeImgdownEN" class="qrcodeImgdownEN"></div>
              Scan qr code for audience pre-registration
              <p style="font-size: 36px">
                You can enter the exhibition site with your ID card
              </p>
            </div>
          </div>
          <div class="footImgen">
            <img src="../../../../static/wxInventFoot.png" alt="" />
          </div>
        </div>
      </div>

      <!--页面上的邀请函样式-->
      <div class="poster" v-if="!posterUrl">
        <div class="header">
          <img src="../../../../static/wxHead2en.png" alt="" srcset="" />
        </div>
        <div class="logo">
          <div
            :style="{
              background: 'url(' + form.imageUrl + ')#f1f1f1 no-repeat center  ',
            }"
            class="upload-logo"
            style="height: 60px"
          >
            <el-upload
              :auto-upload="false"
              :before-upload="beforeAvatarUpload"
              :on-change="changeImg"
              :show-file-list="false"
              action="#"
              class="avatar-uploader"
            >
              <div slot="trigger" style="margin-top:5px">
                <el-button class="upload">Upload logo</el-button>
              </div>
            </el-upload>
          </div>

          <div class="el-upload__tip">
            Format: JPG, PNG; Recommended size: 600 x 240px; Size: within 500KB
          </div>
        </div>
        <div style="margin-top: 67px">
          {{ companychName }}
          <p style="font-size: 14px; font-weight: bold">
            You are cordially invited to visit
          </p>
          <p style="font-size: 14px; margin-top: 10px">China's 19th International Technology Exchange & Equipment Exhibition on Coal & Mining</p>
        </div>
        <div></div>
        <div class="exnumbox" style="margin-top: 15px">
          <div class="exnum1" v-if="booth[selectedBooth]">
            Booth
            <div style="font-size:32px">{{ booth[selectedBooth].Num }}</div>
          </div>
          <div class="address1">
            <p>
              New China International Exhibition Center(NEIEC) Beijing, China
            </p>
            <p>25-28 October 2023</p>
          </div>
        </div>
        <div class="exhumber" style="display:flex;margin-top:31px;align-items:center">
          <p style="font-size: 14px; width:26.6vw">Both No.：</p>
          <el-select v-model="selectedBooth" placeholder="请选择" @change="changeBooth">
            <el-option v-for="item in boothOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
        <div style="margin-top: 15px;display: flex; align-items:center">
          <p style="font-size: 14px; width:26.6vw">Phone Nubmer:</p>

          <el-input v-model="form.phone" style="width:216px" placeholder="please enter" autocomplete="off"></el-input>
        </div>
        <!-- 二维码 -->
        <div class="qrcode1">
          <!-- <img src="../../../../static/activeQrcode.png" alt="" srcset="" /> -->
          <div style="font-size: 15px">
            Scan qr code for audience pre-registration
            <div id="qrcodeImgEN" class="qrcodeImgCN"></div>
            <p style="font-size: 11px; margin-top: 2px">
              You can enter the exhibition site with your ID card
            </p>
          </div>
        </div>
        <div class="footImg1">
          <img src="../../../../static/wxInventFoot.png" alt="" />
        </div>
        <div class="submit">
          <el-button @click="submitForm('form')" :loading="loadingFlag">submit</el-button>
        </div>
      </div>
      <!-- 上传成功显示图片 -->
      <div class="posterImg" v-else>
        <img :src="posterUrl" alt="" srcset="" />
        <div class="button">
          <button class="edit" @click="clearPoster()">ReEdit</button>

          <button class="share" @click="goShare()">Share</button>
        </div>
      </div>
    </div>
    <Share :shareVisiable="shareVisiable" @copyLink="copyLink" @closePannel="closePannel" :shareContentUrl="shareContentUrl" />
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
import Share from '../../../comment/mobile/share.vue';
import html2canvas from 'html2canvas';
import { upload } from '../../../../../api/invite';
import { getExhition } from '../../../../../api/exhibitor';
import { forMat, wxRegister, intercept, imgDownwx } from '../../../../../utils/common';

export default {
  name: 'wxInvite',

  data() {
    return {
      publicUrl: '', //公共路径
      posterUrl: '', //上传后返回的图片路径
      wxDownimg: imgDownwx(),
      Submitted: false, //切换右侧表单
      activeName: 'first', //标签页
      companychName: 'XX公司',
      // 微信分享
      shareVisiable: false, // 弹出面板分享
      copyLink: '', // 要分享得链接
      shareContentUrl: '', //要分享的链接
      //微信分享结束
      boothOption: [],
      selectedBooth: 0,
      booth: [], //展位
      Phone: '', //咨询电话
      registerUrl: '', //微信扫码后注册链接
      weixinUrl: 'test', //微信扫码后保存的图片链接
      imgUrl: '', //海报下载地址
      form: {
        phone: '', //海报中手机号
        imageUrl: '', //海报中logo
      },
      rules: {
        imageUrl: [
          {
            required: true,
            message: 'Please upload pictures',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: 'Please enter the information number',
            trigger: 'blur',
          },
          // {validator: validatorPhone }
        ],
      },
      styleImg: '',
      styleImgPreview: '',
      loadingFlag: false, //生成邀请码加载中的flag
    };
  },
  components: {
    Share,
  },
  created() {
    this.publicUrl = forMat();
    this.registerUrl = wxRegister();

    this.getExhition();
    //生成二维码
    this.$nextTick(function() {
      this.search();
    });
  },

  methods: {
    closePannel(data) {
      this.shareVisiable = data;
    },
    goShare() {
      this.shareVisiable = true;
    },

    changeBooth(value) {
      // console.log(this.selectedBooth, value);
    },
    //获取展商信息
    async getExhition() {
      try {
        let { data } = await getExhition();
        this.companychName = data.data.companyNameE;
        let vm = this;
        data.data.hzBoothList.forEach((item, i) => {
          if (item.boothNum == '' || typeof item.boothNum == 'undefined') item.boothNum = '无';
          if (item.boothName == '' || typeof item.boothName == 'undefined') item.boothName = '无';
          vm.boothOption.push({
            value: i,
            label: item.boothNum,
          });
          vm.booth.push({
            Num: item.boothNum,
            Name: item.boothName,
          });
        });
      } catch (e) {
        console.log('1', e);
      }
    },

    //图片上传成功实现本地预览
    changeImg(res, filelist) {
      let testmsg = res.name.substring(res.name.lastIndexOf('.') + 1); //获取文件后缀
      const extension = testmsg === 'jpg';
      const extension2 = testmsg === 'png';
      const isLt2M = res.size / 1024 < 2048;
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 jpg、png格式!',
          type: 'warning',
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 500kb!',
          type: 'warning',
        });
        return false;
      }

      let _this = this;
      _this.form.imageUrl = URL.createObjectURL(res.raw);
      var reader = new FileReader();
      reader.readAsDataURL(res.raw);
      reader.onload = function() {
        var img = new Image();
        img.src = reader.result;
        //如果存在浏览器缓存中
        if (img.complete) {
          //小于最大宽度和高度，指定最小宽度【宽图logo场景】
          if (img.width < 1000 && img.height < 440 && img.height / img.width < 0.5) {
            _this.styleImg = 'width:1000px';
            _this.styleImgPreview = 'max-width:250px';
          }
          //小图 方图logo
          if (img.width < 1000 && img.height < 440 && img.height / img.width >= 0.5) {
            _this.styleImg = 'max-height:440px';
            _this.styleImgPreview = 'max-height:100px';
          }

          //超过的最大高度和宽度，固定最大高度
          if (img.width > 1000 && img.height > 440) {
            _this.styleImg = 'max-height:440px';
            _this.styleImgPreview = 'max-height:100px';
          }
          //大于最大宽度，小于最小高度【宽度logo典型场景】
          if (img.width > 1000 && img.height < 440) {
            _this.styleImg = 'min-width:1000px';
            _this.styleImgPreview = 'min-width:250px';
          }
          //小于最大宽度，大于最大高度，默许认为是长图
          if (img.width < 1000 && img.height > 440) {
            _this.styleImg = 'max-height:440px';
            _this.styleImgPreview = 'max-height:100px';
          }
          console.log('在缓存', img.width, img.height);
        } else {
          img.onload = function() {
            //小于最大宽度和高度，指定最小宽度【宽图logo场景】
            if (img.width < 1000 && img.height < 440 && img.height / img.width < 0.5) {
              _this.styleImg = 'width:1000px';
              _this.styleImgPreview = 'max-width:250px';
            }
            //小图 方图logo
            if (img.width < 1000 && img.height < 440 && img.height / img.width >= 0.5) {
              _this.styleImg = 'max-height:440px';
              _this.styleImgPreview = 'max-height:100px';
            }

            //超过的最大高度和宽度，固定最大高度
            if (img.width > 1000 && img.height > 440) {
              _this.styleImg = 'max-height:440px';
              _this.styleImgPreview = 'max-height:100px';
            }
            //大于最大宽度，小于最小高度【宽度logo典型场景】
            if (img.width > 1000 && img.height < 440) {
              _this.styleImg = 'min-width:1000px';
              _this.styleImgPreview = 'min-width:250px';
            }
            //小于最大宽度，大于最大高度，默许认为是长图
            if (img.width < 1000 && img.height > 440) {
              _this.styleImg = 'max-height:440px';
              _this.styleImgPreview = 'max-height:100px';
            }
            console.log('不在缓存', img.width, img.height);
          };
        }
      };
    },

    //上传之前的钩子函数
    beforeAvatarUpload(file) {
      return false; //屏蔽了action的默认上传
    },

    //提交表单
    submitForm(formName) {
      this.loadingFlag = true;
      this.createPoster();
      this.Submitted = !this.Submitted;
      this.$message.success('验证通过');
    },

    //切换标签页
    handleClick(tab, event) {
      console.log(tab, event);
    },

    //生成注册二维码
    search() {
      var qrcodedown = new QRCode('qrcodeImgdownEN', {
        width: 330,
        height: 330,
        colorDark: '#000000', //前景色
        colorLight: '#ffffff', //背景色
        correctLevel: QRCode.CorrectLevel.H, //容错级别
      });
      qrcodedown.clear();
      qrcodedown.makeCode(this.registerUrl);

      var qrcode = new QRCode('qrcodeImgEN', {
        width: 90,
        height: 90,
        colorDark: '#000000', //前景色
        colorLight: '#ffffff', //背景色
        correctLevel: QRCode.CorrectLevel.H, //容错级别
      });
      qrcode.clear();
      qrcode.makeCode(this.registerUrl);
    },

    //生成海报
    createPoster() {
      const vm = this;
      const domObj = document.getElementById('imageWrapperEN');
      html2canvas(vm.$refs.imageWrapperEN, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        scale: 1, //放大
        x: vm.getActuralPosition(vm.$refs.imageWrapperEN).left,
        y: vm.getActuralPosition(vm.$refs.imageWrapperEN).top,
      }).then(function(canvas) {
        vm.imgUrl = canvas.toDataURL('image/png');
        canvas.toBlob(function(blob) {
          let theBlob = blob;
          theBlob.lastModifiedDate = new Date();
          theBlob.name = '微信邀请函';
          vm.upload(theBlob); //转换成blob并上传
        });
      });
    },

    //上传邀请函
    async upload(file) {
      try {
        let { data } = await upload(file);

        //上传成功 生成下载图片二维码
        if (data.code === 200) {
          this.posterUrl = this.publicUrl + data.data.url; //拼接接口返回的图片路径
          // console.log(this.posterUrl)
          let url = this.wxDownimg + '?imgurl=' + this.posterUrl;
          this.shareContentUrl = url;
          this.$store.commit('updatewxShare', url);
          const qrcodeImgEl2 = document.getElementById('qrcodeImg21');
          qrcodeImgEl2.innerHTML = '';

          var qrcode = new QRCode('qrcodeImg21', {
            width: 242,
            height: 242,
            colorDark: '#000000', //前景色
            colorLight: '#ffffff', //背景色
            correctLevel: QRCode.CorrectLevel.H, // 容错级别
          });
          qrcode.clear();
          qrcode.makeCode(url);
        } else {
          //失败提示错误信息
          this.$message({
            message: data.msg,
            type: 'warning',
          });
        }
      } catch (e) {
        // this.$message({
        //   message: "网络波动 再试一次吧",
        //   type: "warning",
        // });
        // return false;
      }
    },

    //重新编辑
    clearPoster() {
      this.imgUrl = '';
      this.form.imageUrl = '';
      this.form.phone = '';
      this.Submitted = !this.Submitted;
      this.$router.go(0);
    },

    //获取元素绝对位置
    getActuralPosition(element) {
      let acturalLeft = element.offsetLeft;
      let acturalTop = element.offsetTop;
      let curElement = element.offsetParent;
      while (curElement) {
        acturalLeft += curElement.offsetLeft;
        acturalTop += curElement.offsetTop;
        curElement = curElement.offsetParent;
      }
      return {
        left: acturalLeft,
        top: acturalTop,
      };
    },
  },
};
</script>
<style>
.qrcodeEnn {
  position: absolute;

  width: 1200px;
}

.qrcodeImgdownEN img {
  margin: 0 auto;
  width: 350px !important;
  height: 350px;
}
/* .downloadposter img {
  width: 100%;
} */
.qrcodeImgCN {
  margin: 10px 0 10px;
}
.qrcodeImgCN img {
  margin: 0 auto;
}
.exnumbox {
  display: flex;
  justify-content: space-between;
}
.exnum {
  width: 580px;
  height: 218px;
  line-height: 218px;
  font-size: 48px;
  color: #1c75bc;
  font-weight: bold;
  background: url('../../../../static/boxBG.png') no-repeat;
  /* border: 1px solid red; */
}

.exnum span {
  font-size: 68px;
}
.address {
  /* border: 1px solid red; */
  width: 580px;
  font-size: 33px;
  display: flex;
  font-weight: 500;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url('../../../../static/boxBG.png') no-repeat;
}
.footImgen {
  margin-top: 170px;
}
</style>
<style lang="scss" scoped>
.tishi {
  font-size: 12px;
}
.body {
  font-family: PingFangSC-Regular, PingFang SC;

  .header {
    padding: 0 0 0px 0px;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
}
.content {
  // padding: 100px 120px;
  display: flex;
  align-items: center;

  .left {
    .downloadposter {
      min-width: 1200px;

      // border: 1px solid red;
      // background: url("../../../../static/wxBG.png") no-repeat;
      // background-size: 100% 100%;
      box-sizing: border-box;
      // border: 1px solid red;

      text-align: center;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 58px;
      // color: #fffefe;
      // line-height: 40px;
    .exnumbox {
        width: 100%;
        height: 218px;
        // border: 1px solid red;
        padding-left: 15px;
        padding-right: 15px;
        box-sizing: border-box;
        .exnum1 {
          width: 48%;
          height: 100%;
          font-size: 40px;
          line-height: 40px;
          color: #1c75bc;
          font-weight: bold;
          background: url('../../../../static/boxBG.png');
          background-size: 100% 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          span {
            font-size: 22px;
          }
        }
        .address1 {
          width: 48%;
          height: 100%;
          font-size: 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: url('../../../../static/boxBG.png');
          background-size: 100% 100%;
        }
      }
      .logoIMG {
        margin: 0 auto;
        max-width: 1000px !important;
        max-height: 440px;
        margin-bottom: 22px;
      }

      .logo {
        margin: 0 auto;
        background: #ffffff;
        width: 1000px;
        height: 226px;
        color: #b9b9b9;
        text-align: center;
        line-height: 226px;
        font-size: 100px;
      }

      //二维码样式
      .qrcode {
        margin-top: 45px;
        display: inline-block;
        position: absolute;
        left: 443px;

        ::v-deep img {
          background-color: #fff; //设置白色背景色
          padding: 15px; // 利用padding的特性，挤出白边
          box-sizing: border-box;
        }
      }
    }

    //页面上的邀请函样式
    .poster {
      width: 100%;
      // height: 690px;
      // border: 1px solid red;
      // background: url("../../../../static/wxBG.png") no-repeat;

      box-sizing: border-box;
      // padding-top: 100px;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 16px;
      // color: #fffefe;
      .header {
        img {
          width: 100%;
        }
      }

      .logoIMG {
        margin: 0 auto;
        max-width: 250px;
        max-height: 100px;

        img {
          max-width: 250px;
          max-height: 100px;
        }
      }

      .logo {
        margin: 0 auto;
        background: #ffffff;
        width: 250px;
        height: 50px;
        color: #b9b9b9;
        text-align: center;
        // line-height: 50px;
        font-size: 28px;
      }

      .exnumbox {
        width: 100%;
        height: 80px;
        // border: 1px solid red;
        .exnum1 {
          width: 48%;
          font-size: 16px;
          line-height: 40px;
          color: #1c75bc;
          font-weight: bold;
          background: url('../../../../static/boxBG.png');
          background-size: 100%;
          span {
            font-size: 22px;
          }
        }
        .address1 {
          width: 48%;
          font-size: 11px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: url('../../../../static/boxBG.png');
          background-size: 100%;
        }
      }
      .qrcode1 {
        width: 100%;
        margin: 0 auto;
        margin-top: 20px;
        position: absolute;

        img {
          width: 100px;
        }
      }
      .footImg1 {
        margin-top: 60px;
        img {
          width: 100%;
        }
      }

      //二维码样式
      .qrcode {
        margin-top: 20px;
        display: inline-block;

        ::v-deep img {
          background-color: #fff; //设置白色背景色
          padding: 3px; // 利用padding的特性，挤出白边
          box-sizing: border-box;
        }
      }

      div {
        p {
          margin-top: 5px;
        }
      }
    }
    //上传成功展示邀请得海报图片
    .posterImg {
      img {
        width: 100%;
      }
      .button {
        display: flex;
        justify-content: space-between;
        .edit {
          width: 48%;
          height: 35px;
          background: #fdd000;
          border-radius: 4px;
          border: none;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #006fb8;
        }
        .share {
          width: 48%;
          height: 35px;
          background: #006fb8;
          border: none;
          border-radius: 4px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: white;
        }
      }
    }
  }
  .submit {
    //  border: 1px solid red;
    button {
      width: 100%;
      height: 35px;
      background: #006fb8;
      border: none;
      border-radius: 4px;
      color: white;
    }
  }

  .right {
    margin-left: 102px;
    //提交前右侧样式
    .upload-logo {
      width: 350px;
      height: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      img {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
      }
    }

    //提交后右侧样式
    .submited {
      margin-left: 30px;

      p {
        margin-top: 20px;
      }

      .qrcode2 {
        margin: 39px 0 49px;
      }
    }
  }
}
</style>

<style scoped>
>>> .el-card__body {
  padding: 10px 0;
}

>>> #tab-first {
  padding-left: 30px;
}

>>> .el-button {
  background-color: #006fb8;
  color: #ffffff;
  width: 88px;
  height: 32px;
  padding: 0;
  font-weight: 400;
}

>>> .upload.el-button {
  background-color: #ffffff;
  color: #666666;
  width: fit-content;
}

>>> .submited .el-button {
  min-width: 102px;
}

>>> .submited .clear.el-button {
  background-color: #fdc400;
  margin-right: 20px;
}
</style>
